(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusAssessControllers')
        .controller('RecomActionPlanUpdateStatusAssessController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'bUnit', 'govProcess'];

    function Controller($scope, $state, topBarService, bUnit, govProcess) {

        var title = bUnit.TitleEN + ' Action Plans | Progress Tracking';
        topBarService.setTitleAndIcon(title, 'fa fa-road');

        // Check for active gov process
        var isGovProcDisabled = !_.isObject(govProcess) || _.isUndefined(govProcess.GovernanceProcessID);
        if (!$state.is('recomActionPlanUpdateStatusAssess.noActiveProcess') && isGovProcDisabled) {
            $state.go('recomActionPlanUpdateStatusAssess.noActiveProcess', {}, { location: 'replace' });
            return;
        }

        // Go To First ActionPlan To Assess
        $state.go('recomActionPlanUpdateStatusAssess.actionPlans', {}, { location: 'replace' });
    }
})();